module.exports = __webpack_public_path__ + "media/pdf/AGB_User-4e0cf2fe78e18c9b3c070d5b2677488c.pdf";